// Sidebar entries for the addon apps listed under My Files (AHA-47249 —
// Lesson / Knowledge base / Course). Each entry is gated by its own flag so
// the three ramp independently.
//
// LESSON and KNOWLEDGE_BASE deliberately REUSE the workspace-app flags that
// gate the matching "Create new" dropdown entries (see workspace-app
// frontend/src/app/featureFlags/flags.ts). One flag per addon means the
// sidebar entry and the Create entry appear together — a user can never see
// a menu for a kind they cannot create, or vice versa. Do not mint separate
// presenter flags for these.
export const LESSON_MENU_FLAG = 'AHA-46814-lesson-create'
export const KNOWLEDGE_BASE_MENU_FLAG = 'AHA-46986-knowledge-base'
// Course has no Create entry yet — its flag is owned here (AHA-47249).
export const COURSE_MENU_FLAG = 'AHA-47249-course'

// Same variant-name gate as MY_FILES_MENU_VARIANTS (and workspace-app's
// useFeatureTreatment): only an explicit `treatment` shows the entry, so
// "control" stays distinguishable from "flag failed to load" in Mixpanel.
export const ADDON_MENU_VARIANTS = {
  TREATMENT: 'treatment',
  CONTROL: 'control',
}
